import React from 'react';
import { useTranslation } from 'react-i18next';
import TooltipOverlay from '../tooltip/Tooltip';
import { FiInfo } from 'react-icons/fi';

interface ItemValueSectionProps {
    description?: string;
    displayTooltip?: boolean;
    classes?: string;
}
function ItemValueSection({ description, displayTooltip = false, classes }: ItemValueSectionProps) {
    const { t } = useTranslation();
    return (
        <div className={`my-3 ${classes}`}>
            <div className="d-flex align-items-center">
                <h6 className="mb-1">{t(`brand.campaign.briefing.item_value`)}</h6>
                {displayTooltip && (
                    <TooltipOverlay className="ms-1 mb-0" content={t(`brand.campaign.briefing.item_value_tooltip`)}>
                        <FiInfo size={14} />
                    </TooltipOverlay>
                )}
            </div>
            <p className="text-muted">{description}</p>
        </div>
    );
}

export default ItemValueSection;
